import styled from 'styled-components';

import { colors } from 'global/colors';

export const BannerContainer = styled.div`
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 0.25rem;
  color: ${colors.lightBrown};
  background-color: ${colors.lightYellow};
  border-color: ${colors.lightYellow2};
  text-align: center;
  font-size: 14px;
`;
